import React, { useState, useEffect, useContext } from 'react';
import { Container, Row, Col, Button }            from 'react-bootstrap';
import api                                        from './AxiosConfig';
import { useNavigate }                            from 'react-router-dom';
import { AuthContext }                            from './AuthContext';
import MasterGoal                                 from './MasterGoal';
import ChecklistSummary                           from './ChecklistSummary';
import WeeklySummary                              from './WeeklySummary';
import SystemMessage                              from './SystemMessage';
import { SelectionContext }                       from './SelectionContext';
import { BsFillCaretLeftFill,
         BsFillCaretRightFill}                    from "react-icons/bs";

function Status() {
    
    const [goals,     setGoals]     = useState([]);
    const [clSummary, setClSummary] = useState( false );
    const [wkSummary, setWkSummary] = useState( false );
    const [refresh,   setRefresh]   = useState( true );
    const navigate                  = useNavigate();
    const  { orderEditEnabled, 
             disableOrderEdit,
             wkSummaryPos,
             updateWkSummaryPos,
             clSummaryPos,
             updateClSummaryPos }   = useContext( SelectionContext ); 
    const { isLoggedIn, 
            isLoading,
            user,
            checkSession }          = useContext(AuthContext);

    useEffect(() => {
      const callCheckSession = async () => {
          try {
              await checkSession();
          } catch (error) {
              console.log("Error calling checkSession." + error.message);
          }
      };

      callCheckSession();
    }, []); // only run once on mount

    useEffect(() => {
        const getUserPrefs = async () => {
        try {
            const response = await api.get(`/site/users/${encodeURIComponent(user)}`, {
            withCredentials: true,
            });
           console.log("getUserPrefs = " + JSON.stringify(response.data));
           setClSummary(response.data.checklist_summary_enabled);
           setWkSummary(response.data.weekly_summary_enabled);
           updateClSummaryPos(response.data.checklist_summary_position);
           updateWkSummaryPos(response.data.weekly_summary_position);
        } catch {
            console.log("Error fetching preferences.");
        }
    };

    const fetchGoals = async () => {
        try {
            const response = await api.get('/site/goals/master', { withCredentials: true });
            setGoals(response.data);
        } catch (error) {
            console.error('Error fetching goals:', error);
        }
    };

    // Trigger both when session check is complete and user is logged in
    if ( !isLoading && isLoggedIn === true) {
        getUserPrefs();
        if (refresh) {
            fetchGoals();
            setRefresh( false );
        }
    }
    }, [isLoading, isLoggedIn, refresh]);

    const saveMGDisplayOrder = async ( g, o ) => {
        try {
            const response = await api.put(`/site/goals/display-order/${encodeURIComponent(g)}/${encodeURIComponent(o)}`, {}, { withCredentials: true });
            setRefresh( true );
        } catch {
            console.error("Error saving MG display position.");                 
        }
    }

    const saveClSummaryPos = async ( p ) => {
        try {
            const response = await api.put(`/site/users/cl-summary-position/${encodeURIComponent(p)}`, {}, { withCredentials: true });                 
            setRefresh( true );
        } catch {
            console.error("Error saving CL display position.");
        }
    }

    const saveWkSummaryPos = async ( p ) => {
        try {
            const response = await api.put(`/site/users/wk-summary-position/${encodeURIComponent(p)}`, {}, { withCredentials: true });                 
            setRefresh( true );
        } catch {
            console.error("Error saving Wk display position.");
        }
    }

    const saveOrderEdit = () => {
        disableOrderEdit();
    }
    
  const moveClSummaryUp = () => {
      if ( clSummaryPos < goals.length ) {
          saveClSummaryPos( clSummaryPos +1 );
          updateClSummaryPos( clSummaryPos + 1 );
      }
 }

 const moveClSummaryDown = () => {
      if ( clSummaryPos > 0 ) {
          saveClSummaryPos( clSummaryPos - 1 );
          updateClSummaryPos( clSummaryPos - 1 );
      }
  }

  const moveWkSummaryUp = () => {
      if ( wkSummaryPos < goals.length ) {
          saveWkSummaryPos( wkSummaryPos + 1 );
          updateWkSummaryPos( wkSummaryPos + 1 );
      }
 }

 const moveWkSummaryDown = () => {
      if ( wkSummaryPos > 0 ) {
          saveWkSummaryPos( wkSummaryPos - 1 );
          updateWkSummaryPos( wkSummaryPos - 1 );
      }
  }

 const moveGoalDown = ( id, order) => {
     console.log("moveGoalDown(" + id + ", " + order + ") pos = " + goals[order].mg_display_order);
     if ( order > 0 && goals[order].mg_display_order > 0 ) {
         saveMGDisplayOrder( id, goals[order].mg_display_order - 1 );
     }
 }
 
 const moveGoalUp = ( id, order ) => {
     if ( goals[order].mg_display_order < goals.length ) {
          saveMGDisplayOrder( id, goals[order].mg_display_order + 1);
     }
 }

const closeLoginWarning = () => {
     // do nothing.
}

if ( !isLoggedIn ) return (<SystemMessage message={'You need to log in to access this page.'} closeMessage={closeLoginWarning} />)
         
 return ( <Container className="mt-2">
            <Row className="justify-content-md-left">
              
              {goals.map((goal, index) => (<>
                  { clSummary && ( clSummaryPos === index ) && ( <Col xs={12} md={6} lg={4}>
                      <ChecklistSummary />
                      { orderEditEnabled && (<div className="mb-2 text-center">{ index > 0 && (<BsFillCaretLeftFill onClick={moveClSummaryDown} />)}Display Order {goal.mg_display_order}<BsFillCaretRightFill onClick={moveClSummaryUp}/></div>)}
                    </Col> ) }
                  { wkSummary && ( wkSummaryPos === index ) && ( <Col xs={12} md={6} lg={4}><WeeklySummary /> 
                      { orderEditEnabled && (<div className="mb-2 text-center">{ index > 0 && (<BsFillCaretLeftFill onClick={moveWkSummaryDown} />)}Display Order {goal.mg_display_order}<BsFillCaretRightFill onClick={moveWkSummaryUp}/></div>)}
                    </Col>)} 
              <Col xs={12} md={6} lg={4} key={goal.id}>
                <MasterGoal goalId={goal.id} />
                  { orderEditEnabled && (<div className="mb-2 text-center">{ index > 0 && (<BsFillCaretLeftFill onClick={() => moveGoalDown(goal.id, index)} />)}Display Order {goal.mg_display_order}<BsFillCaretRightFill onClick={() =>moveGoalUp(goal.id, index)}/></div>)}
              </Col>
          </>))}
        { clSummary && (clSummaryPos >= goals.length ) && (<Col xs={12} md={6} lg={4}>
           <ChecklistSummary />
           { orderEditEnabled && (<div className="mb-2 text-center"><BsFillCaretLeftFill onClick={moveClSummaryDown} />Display Order {goals.length}</div>)}
            </Col> )} 
        { orderEditEnabled && (<Col><Button variant="primary" onClick={saveOrderEdit}>Done</Button></Col>)}
        </Row>        
        
        </Container> 
      );
}

export default Status;
